import { useId } from 'react';

/**
 * The "All players" gender chip — dark-purple gradient square with "ALL".
 * Colors are baked in by design (Figma Gender component, variant "All").
 */
export default function GenderAll({ className }: { className?: string }) {
  const uid = useId().replace(/:/g, '');
  const gradientId = `gender-all-gradient-${uid}`;

  return (
    <svg className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient
          id={gradientId}
          x1="16"
          y1="2"
          x2="16"
          y2="30"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7167A4" />
          <stop offset="0.92" stopColor="#63598E" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="28" height="28" rx="3.6" fill={`url(#${gradientId})`} />
      <g fill="#FCF2FF">
        <path
          transform="translate(6.048 11.578) scale(1.3336)"
          d="M4.347 5.202H1.989L1.611 6.318H0L2.286 0H4.068L6.354 6.318H4.725L4.347 5.202ZM3.951 4.014L3.168 1.701L2.394 4.014H3.951Z"
        />
        <path
          transform="translate(15.45 11.578) scale(1.3336)"
          d="M1.539 5.13H3.555V6.318H0V0H1.539V5.13Z"
        />
        <path
          transform="translate(21.168 11.578) scale(1.3336)"
          d="M1.539 5.13H3.555V6.318H0V0H1.539V5.13Z"
        />
      </g>
    </svg>
  );
}
